import type { ProviderRow } from '@/domain/providerConfig';

import type { StatusTone } from './StatusPill';

export interface CardHeaderSummary {
    /** Whether the card has stored rows, so a last fetch can be said at all. */
    hasRows: boolean;
    /** The newest fetch over every pen; null when none was ever fetched. */
    lastFetchedAt: Date | null;
    tone: StatusTone;
    labelKey: string;
    /** The pens connected to the provider, one row each, and how many of them are active. */
    pens: number;
    activePens: number;
}

/** What a provider card's header says of it, from its stored rows (null for a new card). */
export function cardHeaderSummary(rows: readonly ProviderRow[] | null): CardHeaderSummary {
    if (rows === null || rows.length === 0)
        return {
            hasRows: false,
            lastFetchedAt: null,
            tone: 'neutral',
            labelKey: 'providerConfig.accounts.notSetUp',
            pens: 0,
            activePens: 0,
        };
    let lastFetchedAt: Date | null = null;
    for (const row of rows) {
        const fetched = row.health.lastFetchedAt;
        if (fetched !== null && (lastFetchedAt === null || fetched > lastFetchedAt))
            lastFetchedAt = fetched;
    }
    const activePens = rows.filter((row) => row.isActive).length;
    const active = activePens > 0;
    return {
        hasRows: true,
        lastFetchedAt,
        pens: rows.length,
        activePens,
        tone: active ? 'good' : 'neutral',
        labelKey: active
            ? 'providerConfig.integrations.active'
            : 'providerConfig.integrations.inactive',
    };
}
